import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { extractErrorMessage } from "@/lib/apiError";
import { ListChecks, PaperPlaneTilt } from "@phosphor-icons/react";

const C = { teal: "#0A8B85", tealSoft: "#7BD3CE", orange: "#F59E0B" };

export default function FactsQueuePanel({ deck, onUpdated }) {
  const pending = (deck.facts_queue || []).filter((q) => !q.answered);
  const [answer, setAnswer] = useState("");
  const [busy, setBusy] = useState(false);
  if (!pending.length) return null;
  const item = pending[0];
  const total = (deck.facts_queue || []).length;
  const done = total - pending.length;

  const submit = async () => {
    if (!answer.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/pitch/decks/${deck.deck_id}/facts/${item.id}/answer`, { answer });
      onUpdated(data);
      setAnswer("");
      toast.success(`Written into slide ${item.slide}.`);
    } catch (err) {
      if (!err.isCreditShortage) toast.error(extractErrorMessage(err, "Could not save answer"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-5 rounded-lg border px-4 py-3.5"
      style={{ borderColor: "rgba(245,158,11,0.4)", backgroundColor: "rgba(245,158,11,0.07)" }}
      data-testid="facts-queue-panel">
      <div className="flex items-center gap-2 mb-2">
        <ListChecks size={16} weight="bold" style={{ color: C.orange }} />
        <span className="text-[11px] font-bold uppercase tracking-widest" style={{ color: C.orange }}>
          Facts only you can supply · {done}/{total} answered
        </span>
      </div>
      <div className="text-[13px] text-white/85 font-semibold" data-testid="facts-queue-question">
        {item.question}
        <span className="text-white/40 font-normal"> (slide {item.slide} · {item.field})</span>
      </div>
      <div className="mt-2.5 flex gap-2">
        <input value={answer} onChange={(e) => setAnswer(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Your answer — David never guesses this for you"
          data-testid="facts-queue-input"
          className="flex-1 rounded-md px-3 py-2 text-sm text-white bg-white/[0.06] border border-white/10 focus:border-[#F59E0B] focus:outline-none" />
        <button onClick={submit} disabled={busy || !answer.trim()} data-testid="facts-queue-submit"
          className="inline-flex items-center gap-1.5 rounded-md px-4 py-2 text-xs font-bold uppercase tracking-wider disabled:opacity-40"
          style={{ backgroundColor: C.orange, color: "#000" }}>
          <PaperPlaneTilt size={13} weight="fill" /> {busy ? "Saving…" : "Add to slide"}
        </button>
      </div>
    </div>
  );
}
